export default {
      id: "icon--directdebit-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--directdebit-usage",
      toString: function () {
        return this.url;
      }
    }